import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    initialLoading: false,
    initialErrorMessage: null,
    configurationCollection: null,

    countLoading: false,
    countAllLoading: false,

    countResult: null,
    countResultIntegration: null,
    countAllResult: null,
    countAdvancedResult: null,

    countErrorMessage: null,
    countInfoMessage: null,
};

const countToolSlice = createSlice({
    name: "CountTool",
    initialState,
    reducers: {
        clearCountData(state) {
            state.countLoading = false;
            state.countAllLoading = false;

            state.countResult = null;
            state.countResultIntegration = null;
            state.countAllResult = null;
            state.countAdvancedResult = null;

            state.countErrorMessage = null;
            state.countInfoMessage = null;
        },
        getInitialCountToolDataRequest(state) {
            state.initialLoading = true;
            state.initialErrorMessage = null;
            state.configurationCollection = null;
            state.countResult = null;
            state.countResultIntegration = null;
        },
        getInitialCountToolDataSuccess(state, action) {
            state.initialLoading = false;
            state.initialErrorMessage = null;
            state.configurationCollection = action.payload;
        },
        getInitialCountToolDataFailure(state, action) {
            state.initialLoading = false;
            state.initialErrorMessage = action.payload;
            state.configurationCollection = null;
        },
        getIntegrationCountRequest(state, action) {
            state.countLoading = true;
            state.countErrorMessage = null;
            state.countResult = null;
            // countResult carries no integration id; callers key their cache check on this to avoid cross-integration stale counts.
            state.countResultIntegration = action.payload;
        },
        getIntegrationCountSuccess(state, action) {
            // Ignore a response whose integration no longer matches the active request (stale out-of-order fetch).
            if (action.payload.integration !== state.countResultIntegration) {
                return;
            }
            state.countLoading = false;
            state.countResult = action.payload.response;
            state.countInfoMessage = action.payload.warningMessage;
            state.countErrorMessage = null;
        },
        getIntegrationCountFailure(state, action) {
            if (action.payload.integration !== state.countResultIntegration) {
                return;
            }
            state.countLoading = false;
            state.countResult = null;
            state.countResultIntegration = null;
            state.countErrorMessage = action.payload.error;
        },

        // Use another case because the result is another object (not necessary in JS I prefer to make it clear
        getIntegrationAdvancedCountRequest(state) {
            state.countLoading = true;
            state.countErrorMessage = null;
            state.countAdvancedResult = null;
        },
        getIntegrationAdvancedCountSuccess(state, action) {
            state.countLoading = false;
            state.countAdvancedResult = action.payload.response;
            state.countInfoMessage = action.payload.warningMessage;
            state.countErrorMessage = null;
        },
        getIntegrationAdvancedCountFailure(state, action) {
            state.countLoading = false;
            state.countAdvancedResult = null;
            state.countErrorMessage = action.payload;
        },
    },
});

export default countToolSlice;
